import {TroopIcon} from "../ui/tIcon.jsx";
import React from "react";

/**
 * @param units array[11]
 * @param tribe int
 * @constructor
 */
export function UnitRowCompact({units, tribe}) {
    return <div className='unitRowCompact'>
        {
            units.map((unit, id) => ({unit, id}))
                .map(({unit, id}) =>
                    unit === 0 ? <span key={id + 1}></span> :
                        <span key={id + 1}>
                        <TroopIcon tribe={tribe} t={id + 1}/> {unit}
                    </span>
                )
        }
    </div>
}